import { Blockchain } from "@rarible/api-client"
import { toCurrencyId } from "../../../price/types"
import { FEE_CONFIG_URL } from "../constants"
import type { StaticEthereumBlockchainConfig } from "../types"

const rariTestnetViem = {
  id: 1918988905,
  name: "RARI Chain Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Ether (Rari)",
    symbol: "ETH",
  },
  rpcUrls: {
    default: {
      http: ["https://testnet.rpc.rarichain.org/http"],
    },
  },
  blockExplorers: {
    default: {
      name: "RARI Chain Testnet Explorer",
      url: "https://rari-testnet.calderaexplorer.xyz",
    },
  },
  testnet: true,
}

export const rariTestnetConfig: StaticEthereumBlockchainConfig = {
  name: "RARI",
  icon: "/images/blockchains/rari.svg",
  isEvm: true,
  testnet: true,
  isTestnet: true,
  feesVersion: "v3",
  treasury: "0x64d34BcfC32Fb663172C47d6E4Fb1dBFaba6e7a2",
  unionApi: "https://testnet-api.rarible.org",
  basePath: "https://testnet-rari-api.rarible.org",
  chainId: rariTestnetViem.id,
  blockchain: Blockchain.RARI,
  chainName: rariTestnetViem.name,
  exchange: {
    v2: "0x61512179F6a16bEC0D259d8010CC0485CE363868",
    wrapper: "0x3049455cdA17beE43d61090Ec344624aeda72Ed6",
  },
  blockExplorers: [
    {
      url: "https://rari-testnet.calderaexplorer.xyz",
      icon: "/images/scanner.svg",
      adress: "https://rari-testnet.calderaexplorer.xyz/address/${adrress}",
    },
  ],
  rpcUrls: [],
  privateRpcNodeSlug: "testnet-rari-node",
  transferProxies: {
    nft: "0x00C74eD067Cea48F1D6F7D00aBABa3C1D5B2598b",
    erc721Lazy: "0xB8863180CAC2d0Ab665e5968C0De25298A1D8CEe",
    erc20: "0xA094E566b61b3c2D88ACf7Cc15e3Dd0FA83F32af",
  },
  feeConfigUrl: FEE_CONFIG_URL,
  primaryCurrency: {
    id: toCurrencyId("RARI:0x0000000000000000000000000000000000000000"),
    symbol: "ETH",
    name: "Ether (Rari)",
    decimals: 18,
  },
  wrappedCurrency: {
    id: toCurrencyId("RARI:0x2c9dd2b2cd55266e3b5c3c95840f3c037fbcb856"),
    symbol: "WETH",
    name: "wETH (Rari)",
    decimals: 18,
  },
  addFundsLink: "",
  hasStabilityProtocol: false,
  viem: rariTestnetViem,
}

export const getRariTestnetConfig = (): StaticEthereumBlockchainConfig =>
  rariTestnetConfig
